/* loaded by smart-asset */
export default require("./default~kVeqNTdK.png")